var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import TypeFilter from "../components/products/type-filter";
import CategoryFilter from "../components/products/category-filter";
import PillFilter from "../components/products/pill-filter";
import SearchResult from "../components/products/search-results";
import Divider from "../components/divider";
import MobileFilter from "../components/products/mobile-filter";
import Layout from "../layout/layout";
const IconFilter = require('!svg-react-loader?name=LiquorIcon!../../wwwroot/img/icons/icon-filter.svg');
export default class Products extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let sectionRoute = this.props.route === "Ciders & Coolers" ? '/Products/Search?category=CIDERS%20%26%20COOLERS' : `/Products/${this.props.route}`;
        let NavList = [
            { Text: this.props.route, Link: sectionRoute },
            { Text: this.props.typeSelected || 'All', Link: '' }
        ];
        const _a = this.props, { country, region, vintage, varietal } = _a, other = __rest(_a, ["country", "region", "vintage", "varietal"]);
        return (React.createElement(Layout, { route: this.props.route },
            React.createElement(Breadcrumb, { NavList: NavList }),
            React.createElement("div", { style: { padding: "0rem 3rem" } },
                React.createElement("h1", { style: { textAlign: 'center', color: '#b81f25', paddingTop: '1rem' } }, this.props.route)),
            React.createElement("div", { className: "show-more filter-mobile", onClick: this.props.updateMobileToggle },
                "FILTER",
                React.createElement(IconFilter, null)),
            React.createElement(MobileFilter, { toggleMobile: this.props.toggleMobile, updateMobileToggle: this.props.updateMobileToggle, updateSubFilter: this.props.updateSubFilter, clearAll: this.props.clearFilter, currentFilter: { country, region, vintage, varietal }, VarietalList: this.props.FilterTypeOptions.Varietal, CountryList: this.props.FilterTypeOptions.Country, RegionList: this.props.FilterTypeOptions.Region, VintageList: this.props.FilterTypeOptions.Vintage, categoryTypes: this.props.categoryTypes, changeTypes: this.props.changeTypes, typeSelected: this.props.typeSelected, updateOrderBy: this.props.updateOrderBy, currentOrderBy: this.props.currentOrderBy, orderByOptions: this.props.orderByOptions }),
            React.createElement(TypeFilter, { categoryTypes: this.props.categoryTypes, changeTypes: this.props.changeTypes, typeSelected: this.props.typeSelected }),
            React.createElement(CategoryFilter, { category: this.props.route, VarietalList: this.props.FilterTypeOptions.Varietal, CountryList: this.props.FilterTypeOptions.Country, RegionList: this.props.FilterTypeOptions.Region, VintageList: this.props.FilterTypeOptions.Vintage, currentFilter: { country, region, vintage, varietal }, updateSubFilter: this.props.updateSubFilter, typeSelected: this.props.typeSelected, updateOrderBy: this.props.updateOrderBy, currentOrderBy: this.props.currentOrderBy, orderByOptions: this.props.orderByOptions }),
            React.createElement(Divider, null,
                this.props.typeSelected || "ALL",
                " (",
                this.props.count,
                ")"),
            React.createElement(PillFilter, { currentFilter: { country, region, vintage, varietal }, updateSubFilter: this.props.updateSubFilter, clearAll: this.props.clearFilter }),
            React.createElement(SearchResult, { count: this.props.count, products: this.props.products, getProducts: this.props.getProducts })));
    }
}
;
//# sourceMappingURL=products.js.map